import { render, staticRenderFns } from "./calendar-settings-modal.vue?vue&type=template&id=0ce5f574&"
import script from "./calendar-settings-modal.vue?vue&type=script&lang=js&"
export * from "./calendar-settings-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports